import { getBookingProtectionQuote } from 'api/insurance'
import {
  FETCH_BOOKING_PROTECTION_QUOTE,
} from './apiActionConstants'
import { ValueOf } from 'type-fest'
import { API_CALL, SET_BOOKING_PROTECTION_INVALID } from './actionConstants'
import { AppDispatch } from '../store'
import { getBookingProtectionQuoteRequest } from 'checkout/selectors/request/bookingProtection'

type Actions = Utils.FullActionMap<{}>

export type BookingProtectionActions = ValueOf<Actions>

export function fetchBookingProtectionQuote() {
  return (dispatch: AppDispatch, getState: () => App.State) => {
    const state = getState()

    const quotePayload = getBookingProtectionQuoteRequest(state)

    if (!quotePayload) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_BOOKING_PROTECTION_QUOTE,
      schemaRequestData: quotePayload,
      request: () => getBookingProtectionQuote(quotePayload),
    })
  }
}

export function setBookingProtectionInvalid(isInvalid: boolean) {
  return {
    type: SET_BOOKING_PROTECTION_INVALID,
    isInvalid,
  }
}
